module.exports = __webpack_public_path__ + "static/media/loader.5f4164ed.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loader.gif
// module id = 1201
// module chunks = 0